<div class="appropriation-of-profit">
    <div class="profit-calculation-container">
        <aumico-annualReport-profit-calculation-component
            [balanceAccounts]="balanceAccounts"
            [currentAnnualProfit]="currentAnnualProfit"
            [previousAnnualProfit]="previousAnnualProfit"
            [currentYearDate]="currentYearDate"
            [previousYearDate]="previousYearDate"
            [currency]="currency"
            [savedProfitCalculation]="savedProfitCalculation"
            (profitCalculationOutput)="onProfitCalculationChange($event)"
            (profitCalculationPrefilledValue)="onProfitCalculationPrefilledValuePrepared($event)"
            (profitCalculationCurrentRetainedEarnings)="onProfitCalculationCurrentRetainedEarningsChange($event)"
            (profitCalculationPreviousRetainedEarnings)="onProfitCalculationPreviousRetainedEarningsChange($event)"
            [numberFormat]="numberFormat"
            [previousAnnualProfit]="previousAnnualProfit"
            [previousProfitCalculation]="previousProfitCalculation"
            [reportLocale]="reportLocale"
        >
        </aumico-annualReport-profit-calculation-component>
    </div>

    <div class="proposal-container">
        <aumico-annualReport-proposal-component
            [currentYearDate]="currentYearDate"
            [previousYearDate]="previousYearDate"
            [currency]="currency"
            [currentAvailableRetainedEarnings]="currentAvailableRetainedEarnings"
            [previousAvailableRetainedEarnings]="previousAvailableRetainedEarnings"
            [savedProposal]="savedProposal"
            (proposalOutput)="onProposalOutputChange($event)"
            (proposalPrefilledValue)="onProposalPrefilledValuePrepared($event)"
            [numberFormat]="numberFormat"
            [removeEmptyLines]="removeEmptyLines"
            [previousProposal]="previousProposal"
            [reportLocale]="reportLocale"
            [isSavedBefore]="isSavedBefore"
            [savedAopDescription]="savedAopDescription"
            [previousAopDescription]="previousAopDescription"
            (aopDescriptionChange)="onAopDescriptionChange($event)"
        >
        </aumico-annualReport-proposal-component>
    </div>

    <!-- CCR Toggle Button -->
    <div class="ccr-toggle">
        <ham-button
            outline="true"
            [size]="'xs'"
            [icon]="showCcrTable ? 'assets/hamIcons/minus-outline.svg' : 'assets/hamIcons/plus-outline.svg'"
            (buttonClick)="toggleCcrTable()"
        >
            {{ showCcrTable
                ? ('aumico_annual_report_ccr_toggle_hide' | i18next)
                : ('aumico_annual_report_ccr_toggle_show' | i18next) }}
        </ham-button>
    </div>

    <!-- CCR Component -->
    <div class="ccr-container" *ngIf="showCcrTable">
        <aumico-annualReport-ccr-component
            [currentYearDate]="currentYearDate"
            [previousYearDate]="previousYearDate"
            [currency]="currency"
            [numberFormat]="numberFormat"
            [savedCcr]="savedCcr"
            [previousCcr]="previousCcr"
            [equityAccounts]="equityAccounts"
            [balanceTemplate]="balanceTemplate"
            [reportLocale]="reportLocale"
            [isSavedBefore]="isSavedBefore"
            (ccrOutput)="onCcrOutputChange($event)"
            (ccrPrefilledValue)="onCcrPrefilledValuePrepared($event)"
        >
        </aumico-annualReport-ccr-component>
    </div>
</div>
